import React, { useEffect, useState } from 'react';
import { Chip } from '@material-ui/core';

import { getRequest } from 'utils/api';
import CloseIcon from 'public/icons/close-white.svg';
import styles from 'styles/components/influencerSetup/TraitSelection.module.scss';

const FilterTraits = ({ setSelectedTraits, selectedTraitsArray, selectedTraitIds }) => {
  const [traitCategories, setTraitCategories] = useState([]);

  const getFilteredTraits = categoryId =>
    selectedTraitsArray.filter(trait => trait.categoryId === categoryId);

  const addTag = (category, trait) => {
    const categoryId = category.id;
    const traitName = trait.name;
    const traitId = trait.id;

    setSelectedTraits(prevSelectedTraits => {
      const tags = prevSelectedTraits[categoryId] || [];

      const updatedTraits = [...tags, { name: traitName, id: traitId, categoryId }];
      return { ...prevSelectedTraits, [categoryId]: updatedTraits };
    });
  };

  const removeTag = (traitId, tagId) => {
    setSelectedTraits(prevTags => {
      const updatedTags = prevTags[traitId].filter(tag => tag.id !== tagId);

      if (updatedTags.length === 0) {
        const { [traitId]: _, ...rest } = prevTags;
        return rest;
      }

      return { ...prevTags, [traitId]: updatedTags };
    });
  };

  useEffect(() => {
    getRequest({ endpoint: 'trait_categories' })
      .then(categories => setTraitCategories(categories))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (selectedTraitIds.length === 0) return;

    traitCategories.forEach(category => {
      category.traits.forEach(trait => {
        if (selectedTraitIds.includes(trait.id)) {
          addTag(category, trait);
        }
      });
    });
  }, [selectedTraitIds, traitCategories]);

  return (
    <div className={styles.container} style={{ padding: 0 }}>
      {traitCategories.map(category => (
        <div key={category.id} className={styles.traitsBox}>
          <div
            className={styles.selectedContainer}
            style={{ padding: '0 0 10px', borderBottom: 0 }}
          >
            {getFilteredTraits(category.id)?.length > 0 && (
              <div className={styles.subTitle}>
                <h4 style={{ marginBottom: 2 }}>Selected</h4>
              </div>
            )}

            <div className={styles.selectedTags}>
              {getFilteredTraits(category.id)?.map(tag => (
                <Chip
                  key={tag.id}
                  label={tag.name}
                  color="secondary"
                  deleteIcon={<CloseIcon />}
                  className={styles.chip}
                  onDelete={() => removeTag(category.id, tag.id)}
                  onClick={() => removeTag(category.id, tag.id)}
                />
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ marginBottom: 5 }}>{category.name}</h4>

            <div className={styles.popularTags}>
              {category.traits.map(trait => (
                <Chip
                  key={trait.id}
                  label={trait.name}
                  color="secondary"
                  variant="outlined"
                  className={styles.chip}
                  onClick={() => addTag(category, trait)}
                  disabled={selectedTraitsArray.some(
                    selectedTrait => selectedTrait.id === trait.id
                  )}
                  clickable
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FilterTraits;
